export class CustomPromptRequest {
    public prompt: string;
    public proposalText: string;
    public proposalItemUniqueId : string;
    public files: File[];
}